// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AutoRedirectController from './auto_redirect_controller'
application.register('auto-redirect', AutoRedirectController)

import ClipboardController from './clipboard_controller'
application.register('clipboard', ClipboardController)

import LemonwayIframeController from './lemonway_iframe_controller'
application.register('lemonway-iframe', LemonwayIframeController)
